import * as FirstProfRegist from '../../constants/User/FirstProfRegist.js';
import axios from 'axios';

import * as SG from '../../constants/AppSettings'
import { signInCheck, noticeAdd, loadStart, loadEnd } from '../App';

export function resetState() {
  return {
    type: FirstProfRegist.USER_PROF_REGIST_RESET
  }
}

export function noticeInFirstProfRegist(msg, type) {
  return dispatch => {
    dispatch(noticeAdd(msg, type))
  }
}

export function firstProfRegist(formData) {
  return dispatch => {
    dispatch(loadStart())
    dispatch(firstProfRegistRequest());
    // if (!formData['user[photo]']) {
    //   delete formData['user[photo]']
    // } else {

    // }

    // var ua = window.navigator.userAgent
    // console.log('UA', window.navigator.userAgent, navigator.userAgent)

    // if (ua && /iPhone/.test(ua)) {
    //   ua.match(/iPhone OS (\w+){1,3}/g);
    //   var iosv = (RegExp.$1.replace(/_/g, '') + '00').slice(0, 3);
    //   if (iosv === '113') {
    //     if (!formData['user[photo]']) {
    //       formData.delete('user[photo]'); //name属性をdelete
    //     }
    //   }
    // }


    axios.post(SG.USER_FIRST_REGIST_URL, formData, {
      'headers': {
        'Authorization': localStorage.getItem('token'),
        'content-type': 'multipart/form-data'
      }
    })
      .then(function (r) {
        dispatch(signInCheck())
        dispatch(firstProfRegistResult('success'))
        dispatch(loadEnd())
        dispatch(noticeAdd(`登録が完了しました！`,'success'))
      })
      .catch(function (r) {
        dispatch(firstProfRegistResult('error'))
        dispatch(loadEnd())
        // console.log('エラー', r, r.response, r.data)
        if (!r.response && !r.data) {
          dispatch(noticeAdd('登録エラー。管理者にお問い合わせ下さい', 'error'))
        } else {
          const errors = r.response.data.messages
          if (errors && errors.length > 0) {
            dispatch(noticeAdd(errors, 'error'))
          } else {
            dispatch(noticeAdd('サーバーとの接続に失敗しました', 'error'))
          }
        }
        
      });

  }
}

export function firstProfRegistRequest() {
  return {
    type: FirstProfRegist.USER_PROF_REGIST_REQUEST
  }
}

export function firstProfRegistResult(result) {
  return {
    type: FirstProfRegist.USER_PROF_REGIST_RESULT,
    result
  }
}


// WEBPACK FOOTER //
// ./src/actions/User/FirstProfRegist.js